import { OAuthFacebookProvider } from './oauth.provider.facebook'
import { OAuthGoogleProvider } from "./oauth.provider.google";
import { OAuthBennetProvider } from "./oauth.provider.bennet";


import { container } from './container'
import { UserApi } from '../api/UserApi'
import * as Cookies from 'js-cookie'

export class OAuth {
	constructor () {
		this.api = new UserApi()
	}

	/**
	 * Sign in
	 *
	 * @param {User} user
	 *
	 * @return {Observable}
	 */
	providerSignIn (provider, vars, redirectLoggedUrl, options) {
		provider = this.getProviderByName(provider)

		container.get('services.cookies').set('redirect_logged_url', redirectLoggedUrl ? redirectLoggedUrl : window.location.pathname)

		window.location.href = provider.getAuthorizeUrl(options)
	}

	setCookieToken (token) {
		container.get('services.cookies').set('token', token)
	}

	getToken () {
		return container.get('services.cookies').get('token')
	}

	providerSignInCode (providerName, vars) {
		var provider = this.getProviderByName(providerName)
		var params = provider.getParamsAccessToken(vars)

		params.ref_friend = container.get('services.cookies').get('ref_invite', '/')
		params.ref = container.get('services.cookies').get('ref', '/')

		params.utm_source = container.get('services.cookies').get('utm_source', '/')
		params.utm_name = container.get('services.cookies').get('utm_name', '/')
		params.utm_campaign = container.get('services.cookies').get('utm_campaign', '/')
		params.utm_medium = container.get('services.cookies').get('utm_medium', '/')
		params.referrer = container.get('services.cookies').get('referrer', '/')
		
		return !params.access_token
			? this.api.oauthProviderRequestToken(providerName, params).then(response => {
				this.setCookieToken(response.body.data.resource.access_token)
			})
			: this.api.oauthProviderExchangeToken(providerName, params).then(response => {
				this.setCookieToken(response.body.data.resource.access_token)
			})
	}


	signIn (params, options) {
		return this.api.signIn(params, options).then(response => {
			this.setCookieToken(response.body.data.access_token)
		})
	}

	signInAuthToken (authToken) {
		return this.api.signInAuthToken(authToken).then(response => {
			this.setCookieToken(response.body.data.resource.access_token)
		})
	}

	signUp (params) {
		return this.api.signUp(params)
	}

	createGuest (params) {
		return this.api.createGuest(params)

		.then(response => {
			// container.get('services.cookies').set('token_tmp', response.body.data.access_token)
			this.setCookieToken(response.body.data.access_token)
		})
	}

	authenticate (vars) {
		var accessToken = container.get('services.cookies').get('token')

		if (!accessToken) {
			return Promise.reject();
		}

		return this.api.getUser(accessToken).then(response => {

	      window.dispatchEvent(new CustomEvent('quomi.event', { 
	        bubbles: true, 
	        detail: {
	          name: 'authenticate',
	          vars: {
	            user: response.body.data.resource
	          }
	        } 
	      }));

			return response
		})
	}

	getProviderByName (provider) {
		var providers = {
			facebook: new OAuthFacebookProvider(),
			google: new OAuthGoogleProvider(),
			bennet: new OAuthBennetProvider()
		}

		return typeof providers[provider] !== 'undefined' ? providers[provider] : null
	}

	getUser (vars) {
		var accessToken = container.get('services.cookies').get('token')

		return this.api.getUser(accessToken)
	}

	confirmEmail (params) {
		return this.api.confirmEmail(params).then(response => {
			this.setCookieToken(response.body.access_token)
		})
	}

	requestConfirmEmail (params) {
		return this.api.requestConfirmEmail(params)
	}

	logout () {


  		if(window.location.hostname.indexOf("bennet") > -1) {
			let providerName = 'bennet'

			var provider = this.getProviderByName(providerName)
			var params = provider.getParamsAccessToken({})

			return !params.access_token
				? this.api.oauthProviderRemoveToken(providerName, params)
				: this.api.oauthProviderDeleteToken(providerName, params);

		} else {
			return Promise.resolve(1).then(i => {
				container.get('services.cookies').remove('token')
			})
		}
	}
}
